
import { CustomLoading } from 'common'
import { Alert } from '@mui/material'


export const ReportViewer = ({ useFetchInit, dataModal }) =>{

    const {
        FetchData
    } = useFetchInit

    const { fetchPdfAdminToCentral } = FetchData
    const { dataPdfAdminToCentral, loadingFetchPdfAdminToCentral } = fetchPdfAdminToCentral
    // const { docName, docBase64 } = exitPassReportBase64

    // const { dataRequest } = dataModal
    // const { docType } = dataRequest

    // console.log('docType ::: ', docType)

    
    // const docName = docType === 'EXIT_PASS' ? exitPassReportBase64.docName : returnCertificateReportBase64.docName
    // const docBase64 = docType === 'EXIT_PASS' ? exitPassReportBase64.docBase64 : returnCertificateReportBase64.docBase64

    return(
        <>
            {(loadingFetchPdfAdminToCentral)&&(<CustomLoading/>)}
            {(!loadingFetchPdfAdminToCentral && dataPdfAdminToCentral?.flag === 'FAIL')&&(
                <Alert severity="error">
                    {dataPdfAdminToCentral.message}
                </Alert>
            )}
            {(!loadingFetchPdfAdminToCentral
                && typeof dataPdfAdminToCentral === 'string'
                && dataPdfAdminToCentral !== '')&&(
                <iframe
                    src={dataPdfAdminToCentral}
                    width="100%"
                    height="700"
                    style={{ border: "none" }}
                    title="Traslado de efectivo de cajas administrativas a cajas centrales"
                />
            )}
        </>
    )
}
